import React from 'react';
import { Mutation, Query } from "react-apollo";
import queries from '../../queries';

export default function PopUpEditor({ date, setDate, prizes, total_prizes, query }) {

    const [selectedPrize, setSelectedPrize] = React.useState(null);

    return(
        <div onClick={()=>{setDate(null)}} style={{backdropFilter: 'blur(5px)', position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1000, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: 'rgba(0, 0, 0, 0.5)'}}>
            <div onClick={(e)=>{e.stopPropagation()}} style={{backgroundColor: 'white', padding: '20px', borderRadius: '10px', width: '60%', color: 'black'}}>
                <h3>Editor</h3>
                <p>Selected Date: {date && typeof date.format === 'function' ? date.format('YYYY-MM-DD') : 'None'}</p>
                {
                    prizes && prizes.length > 0 ? (
                        <ul>
                            {prizes.map((prize, index) => {
                                const distribution = prize.prizes_distribution.find((pd) => {
                                    return isSameDay(new Date(pd.date), new Date(date));
                                });

                                if(!distribution) {
                                    return null;
                                }
                                return (
                                    <CardProduct key={prize.id} prize={prize} distribution={distribution}/>
                                );
                            })}
                        </ul>
                    ) : (
                        <>
                            <p>No prizes available.</p>
                        </>
                    )
                }
                <form onSubmit={(e) => {e.preventDefault(); query({variables: {input: {prize_id: selectedPrize, date: new Date(date)}}})}}>
                    <select style={{fontSize: '2em'}} required onChange={(e)=>{setSelectedPrize(e.target.value)}}>
                        <option value={selectedPrize}>Select a prize</option>
                            {total_prizes.map((prize, index) => (
                            !prize.prizes_distribution.find((pd)=>{return isSameDay(new Date(pd.date), new Date(date))}) && <option key={index} value={prize.id}>{prize.label}</option>
                        ))}
                    </select>
                    <button type='submit' style={{fontSize: '2em', marginLeft: '10px'}}>Add</button>                    
                </form>
                <br/>
                <br/>
                <button style={{fontSize: '2em'}} className='' onClick={() => setDate(null)}>Close</button>
            </div>
        </div>
    )
}

function CardProduct({ prize, distribution }) {

    const [currentDistribution, setCurrentDistribution] = React.useState(distribution);

    return (
        <Mutation mutation={queries.games.updatePrizesDistribution} refetchQueries={queries.games.getGameById} variables={{input: {id: currentDistribution.id, qts: currentDistribution.qts}}}>
            {
                (mutation)=>{
                    return(
                        <li key={prize.id} style={{ listStyle: 'none', marginBottom: '20px', fontSize: '32px' }}>
                            {prize.label}
                            <input
                                min={0}
                                onChange={(e) => {
                                    setCurrentDistribution({ ...currentDistribution, qts: e.target.value });
                                }}
                                style={{ fontSize: '30px', width: '4em', marginLeft: '10px' }}
                                type="number"
                                value={currentDistribution.qts || 0}
                                />
                            <button onClick={()=>{mutation({variables: {input: {id: currentDistribution.id, qts: parseInt(currentDistribution.qts), hours: currentDistribution.hours}}})}} style={{fontSize: '30px', marginLeft: '10px'}}>
                                Save
                            </button>
                            <img src={prize.image_uri} alt={prize.label} style={{ width: '40px', height: '40px', marginLeft: '10px', marginTop: '18px', border: "solid 1px black" }} />
                        </li>
                    )
                }
            }
        </Mutation>
    );
}

function isSameDay(d1, d2) {
    return (
        d1.getFullYear() === d2.getFullYear() &&
        d1.getMonth() === d2.getMonth() &&
        d1.getDate() === d2.getDate()
    );
}
